import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ControlCamera = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
    strokeAsPrimary: true,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 17 13'
    >
      <path
        fill={primaryColorToUse}
        d='M0 3.108C0 2.284.32 1.493.888.91A3 3 0 0 1 3.03 0h5.051c.804 0 1.575.327 2.143.91.569.583.888 1.374.888 2.198v6.216c0 .824-.32 1.615-.887 2.198-.569.583-1.34.91-2.144.91H3.031a3 3 0 0 1-2.143-.91A3.15 3.15 0 0 1 0 9.324zm14.182 8.056-1.597-1.458V2.725l1.596-1.457a1.243 1.243 0 0 1 1.798.395c.12.202.183.434.183.67v7.765c0 .236-.063.468-.182.67-.12.202-.29.367-.494.477a1.24 1.24 0 0 1-1.305-.081'
      />
    </svg>
  );
};
